import { Flex, Text } from "@chakra-ui/react";
import * as React from "react";
import { translateSubElementString } from "../../../../../../../utils";
import { NumberField } from "../../../../../../../components/NumberField";
import CategoryPreviewWrapper from "./CategoryPreviewWrapper";

function InvestmentsPreview({ currentElement: { totalCo2Emissions } = { totalCo2Emissions: null } }) {
  return (
    <CategoryPreviewWrapper>
      <Flex marginBlockEnd={4}>
        <Text size="sm" fontWeight="bold">
          {translateSubElementString(
            "reportsPage.scopeThree.inputs.mainTotalEmissions"
          )}
        </Text>
        <NumberField value={totalCo2Emissions} marginStart="2" />
      </Flex>
    </CategoryPreviewWrapper>
  );
}

export default InvestmentsPreview;